<div id="join" style="margin-top: 100px;">
  <div id="join-dialog">
    <h2 style="font-family: Noto Sans JP;">{{ "joinRoom" | translate }}</h2>
    <form [formGroup]="roomForm" (ngSubmit)="joinRoom()">
      <div>
        <label for="room-name" style="font-family: Noto Sans JP;">{{ "roomName" | translate }}</label>
        <input formControlName="roomName" id="room-name" class="form-control" type="text" />
      </div>
      <div style="display: flex; justify-content: center;">
        <button class="btn btn-lg btn-success" (click)="goBack()" style="background-color: transparent; color: black;">{{ "back" | translate }}</button>
        <button class="btn btn-lg btn-success" type="submit" [disabled]="!roomForm.valid">{{ "join" | translate }}</button>
      </div>
    </form>
  </div>
</div>
